import styled from "styled-components";

export const ButtonGroup = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
`;

export const ButtonContainer = styled.div`
    margin: 10px;
`;

export const ConfigContainer = styled.div`
  width: 100%;
`
